// components/DeviceFirmwareFlash.tsx
// 기기 화면의 [펌웨어 다운로드] 버튼: 누르면 설치 패널이 열린다. 무선(OTA)이 아니라 USB(COM 포트)로 설치한다.
// 설치는 FirmwareFlasher 가 한다. 펌웨어 파일은 GitHub(kdi6033/download)의 <기기유형>.ino.merged.bin 이다.
import React, { useState } from 'react';
import FirmwareFlasher from './FirmwareFlasher';

const RAW = 'https://raw.githubusercontent.com/kdi6033/download/main/';

interface Props {
  type: string; // 예: 'i2r-03'
}

const DeviceFirmwareFlash: React.FC<Props> = ({ type }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ textAlign: 'right' }}>
      <button type="button" className="action-btn btn-primary" onClick={() => setOpen((o) => !o)}>
        ⬇ 펌웨어 다운로드
      </button>
      {open && (
        <div style={{ marginTop: '10px' }}>
          <FirmwareFlasher title={type} fileUrls={[RAW + `${type}.ino.merged.bin`]} />
        </div>
      )}
    </div>
  );
};

export default DeviceFirmwareFlash;
